var $ = global.jQuery = global.$;

var Slider = require('./Slider');

/**
 * Double fragment slider widget. Extends Slider widget with some different widget options
 * @class
 * @extends Slider
 * @example <div data-widget="DoubleSlider"></div>
 */

var DoubleSlider = Slider.extend(
  /** @lends DoubleSlider.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.widgetOptions.responsive = [{
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }];

    this._super();
  }
});

module.exports = DoubleSlider;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/DoubleSlider.js
// module id = 35
// module chunks = 0 1